Auth = require 'app/scripts/db/auth'
_ = require 'underscore'
moment = require 'moment'

# Okay, so this is a little bit crazy, but it's a relatively simple way to push the mess of timezones
# off onto the browser vendors
module.exports = ->
  return if !Auth.isLoggedIn()
  member = Auth.me()

  # From the internet: https://gist.github.com/jdbartlett/3915761
  tzAbbr = (dateObject) ->
    dateString = dateObject + ""
    abbr = (
      # Works for the majority of modern browsers
      dateString.match(/\(([^\)]+)\)$/) ||
      # IE outputs date strings in a different format:
      dateString.match(/([A-Z]+|UTC[+-]\d{4}) [\d]{4}$/)
    )

    if abbr
      abbr = abbr[1]
      # Old Firefox uses the long timezone name (e.g., "Central
      # Daylight Time" instead of "CDT")
      # Timezones like "AUS Eastern Standard Time" are a thing; should be
      # abbreviated as AEST
      if /\s/.test(abbr) # It's a list of words, we'd only want the first letters
        abbr = abbr.replace(/(\S)\S*/g, (all, initial) -> initial)

      letters = abbr.toUpperCase().match(/[A-Z]/g) ? []
      abbr = letters.join("")

      while abbr.length < 2
        abbr += "?"
    else
      # Fall back to just using UTC+01:00 style
      offset = dateObject.getTimezoneOffset()
      abbr = "UTC" +
        (if offset < 0 then "+" else "-") +
        ("00" + Math.floor(Math.abs(offset) / 60)).substr(-2) +
        ":" +
        ("00" + Math.abs(offset) % 60).substr(-2)

    abbr

  offsetCurrent = offsetNext = dateNext = null

  d = new Date()

  offsetCurrent = d.getTimezoneOffset()
  timezoneCurrent = tzAbbr(d)
  msInMinute = 60 * 1000

  # Let's figure out when the next offset will be
  # We assume that no DST period will be less than 30 days
  for i in [0..12]
    d = moment(d).add(30, 'days').toDate()
    if d.getTimezoneOffset() != offsetCurrent
      # We found a date with a different offset, so that must have happened after the switch
      dateNext = d
      break

  # Was there a date after "now" that had a different timezone offset?
  if dateNext?
    offsetNext = dateNext.getTimezoneOffset()
    # Binary search to figure out when the offset changes
    msBefore = (new Date()).getTime()
    msAfter = dateNext.getTime()
    count = 0
    while ( msAfter > msBefore + msInMinute / 2 ) && count < 30
      count++
      msBetween = Math.floor((msBefore + msAfter) / 2)
      offsetBetween = (new Date(msBetween)).getTimezoneOffset()
      if offsetBetween == offsetCurrent
        msBefore = msBetween
      else if offsetBetween == offsetNext
        msAfter = msBetween
      else
        # What?
        break

    timezoneNext = tzAbbr(dateNext)
    # Round the after date to the nearest minute
    dateNext = (new Date(msInMinute * Math.floor(msAfter / msInMinute))).toISOString()

  newTimezoneInfo = {}
  for key, value of { offsetCurrent, timezoneCurrent, offsetNext, timezoneNext, dateNext } when value?
    newTimezoneInfo[key] = value

  oldTimezoneInfo = member.getPref('timezoneInfo')
  if !_.isEqual(newTimezoneInfo, oldTimezoneInfo)
    member.run('timezoneInfo', newTimezoneInfo)
